import { Typography, IconButton, Tooltip, Popover } from '@mui/material';
import React, { useState } from 'react';
import {
  Close as CloseIcon,
  InfoOutlined as InfoIcon,
  Visibility,
  VisibilityOff,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const RenderInputField = ({
  label,
  value,
  setter,
  placeholder,
  required,
  classes,
  disabled,
  tooltipMessage,
  isSensitive,
}: {
  label: string;
  value: string | number;
  setter: (value: string) => void;
  placeholder: string;
  required?: boolean;
  disabled?: boolean;
  classes: Record<string, string>;
  tooltipMessage?: string;
  isSensitive?: boolean;
}) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [showField, setShowField] = useState(false);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const toggleSensitiveFieldsVisibility = () => {
    setShowField(!showField);
  };

  const open = Boolean(anchorEl);

  return (
    <div className={`${classes.inputMagicline} ${disabled ? classes.itemDisabled : ''}`}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Typography variant="body2" className={classes.selectLabel}>
          {label}
        </Typography>

        {tooltipMessage && (
          <>
            <IconButton aria-label="info" onClick={handlePopoverOpen} style={{ marginLeft: '8px' }}>
              <Tooltip title={t('form.field.eventGroup.moreInfo')} arrow>
                <InfoIcon color="primary" />
              </Tooltip>
            </IconButton>

            <Popover
              open={open}
              anchorEl={anchorEl}
              onClose={handlePopoverClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
            >
              <div style={{ padding: '16px', maxWidth: '200px' }}>
                <Typography marginTop={'16px'}>{tooltipMessage}</Typography>
                <IconButton
                  aria-label="close"
                  onClick={handlePopoverClose}
                  style={{ position: 'absolute', top: '2px', right: '2px' }}
                >
                  <CloseIcon />
                </IconButton>
              </div>
            </Popover>
          </>
        )}
      </div>

      <div
        className={classes.selectedItems}
        style={{ position: 'relative', display: 'flex', alignItems: 'center' }}
      >
        <input
          required={required}
          className={`${classes.setupInput}`}
          placeholder={placeholder}
          value={value}
          onChange={(e) => setter(e.target.value)}
          disabled={disabled}
          type={isSensitive && !showField ? 'password' : 'text'}
          style={{ paddingRight: isSensitive ? '52px' : undefined }}
        />
        {isSensitive && (
          <IconButton
            onClick={toggleSensitiveFieldsVisibility}
            style={{
              position: 'absolute',
              right: '8px',
              top: '50%',
              transform: 'translateY(-50%)',
            }}
          >
            {showField ? <VisibilityOff color="secondary" /> : <Visibility color="primary" />}
          </IconButton>
        )}
      </div>
    </div>
  );
};

export default RenderInputField;
